import React from 'react';
import { LegislationItemType } from '../searchAutocomplete.types';
import { AutocompleteItem } from '../AutocompleteItem';
import {
  AutocompleteEntityItem,
  AutocompleteEntityItemLabel,
} from '../entities/EntitiesLib';
import { wantToOpenInNewTab } from '../../../../../utils/linkUtils';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';
import { getLegislationUrl } from '../../../../../legislation/utils/legislationUtils';
import { ReactComponent as Legislation } from '../../../../../../icons/entities/law.svg';
import { openNewTab } from '../../../../../utils/domUtils';
import { AutocompleteIcon } from '../icon/AutocompleteIcon';

type Props = {
  item: LegislationItemType;
  label: string;
  selected: boolean;
  hasOffset: boolean;
  onClick: () => void;
};

class RawAutocompleteLegislationItem extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.source = 'autocomplete_result';
  }

  onClick = (event: React.MouseEvent<HTMLSpanElement>) => {
    const { item, onClick } = this.props;
    const legislationPageUrl = buildUrlWithParameters(
      getLegislationUrl(
        item.metadata.leg_id,
        item.metadata.legislation_type,
        item.metadata.inner_type,
      ),
      {
        source: this.source,
      },
    );
    onClick();
    if (wantToOpenInNewTab(event)) {
      openNewTab(legislationPageUrl);
    } else {
      window.location.href = legislationPageUrl;
    }
  };

  source: string;

  render() {
    const { selected, label, hasOffset } = this.props;
    return (
      <AutocompleteItem
        data-test-id="autocomplete-legislation-item"
        hasOffset={hasOffset}
        isSelected={selected}
        onClick={this.onClick}
      >
        <AutocompleteEntityItem selected={selected} title={label}>
          <AutocompleteIcon icon={Legislation} />
          <AutocompleteEntityItemLabel>{label}</AutocompleteEntityItemLabel>
        </AutocompleteEntityItem>
      </AutocompleteItem>
    );
  }
}

export const AutocompleteLegislationItem = RawAutocompleteLegislationItem;
